import React from 'react';
import { Drawer, Box, Typography, IconButton, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const DetailsDrawer = ({ isOpen, onClose, selectedItem, workflows=[], newEvents=[] }) => {
  // Helper function to check if the camera or traffic signal is part of any workflow
  const getWorkflowStatus = () => {
    if (!selectedItem || !workflows) return 'No workflows associated.';
    const relatedWorkflows = workflows.filter(workflow => workflow.itemId === selectedItem._id);
    return relatedWorkflows.length > 0 ? `Associated with ${relatedWorkflows.length} workflow(s).` : 'No workflows associated.';
  };

  // Helper function to display recent events
  const getRecentEvents = () => {
    if (!newEvents || newEvents.length === 0) return 'No recent events.';
    return newEvents.map((event, index) => (
      <Typography variant="body2" key={index}>
        - {event.description} at {new Date(event.timestamp).toLocaleString()}
      </Typography>
    ));
  };

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={onClose}
      sx={{ width: '20%' }}
    >
      <Box sx={{ padding: 2, width: '300px' }}>
        <IconButton onClick={onClose} sx={{ float: 'right' }}>
          <CloseIcon />
        </IconButton>
        {selectedItem && (
          <Box>
            <Typography variant="h6" gutterBottom>
              {selectedItem.name || selectedItem['Location Name']}
            </Typography>
            <Typography variant="body1">
              <strong>Type:</strong> {selectedItem.type || 'Camera'}
            </Typography>
            <Typography variant="body2">
              <strong>Coordinates:</strong> {selectedItem.Location.coordinates.join(', ')}
            </Typography>

            {/* Workflow Status */}
            <Typography variant="body2" sx={{ marginTop: 2 }}>
              <strong>Workflow Status:</strong> {getWorkflowStatus()}
            </Typography>

            {/* Screenshot of the Camera */}
            {selectedItem['Screenshot Address'] ? (
              <Box sx={{ marginTop: 2 }}>
                <Typography variant="body2"><strong>Camera Screenshot:</strong></Typography>
                <img
                  src={selectedItem['Screenshot Address']}
                  alt="Camera Screenshot"
                  style={{ width: '100%', borderRadius: '8px' }}
                />
              </Box>
            ) : (
              <Typography variant="body2" sx={{ marginTop: 2 }}>
                <strong>Screenshot:</strong> Not available
              </Typography>
            )}

            {/* Recent Events */}
            <Box sx={{ marginTop: 2 }}>
              <Typography variant="body2"><strong>Recent Events:</strong></Typography>
              {getRecentEvents()}
            </Box>

            {/* More Details Button */}
            <Button
              variant="contained"
              color="primary"
              fullWidth
              sx={{ marginTop: 3 }}
              onClick={() => window.location.href = `/asset/${selectedItem.type}/${selectedItem._id}`}
            >
              More Details
            </Button>
          </Box>
        )}
      </Box>
    </Drawer>
  );
};

export default DetailsDrawer;
